import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const createConsortiumGroup = async ({
  fa_id,
  cg_name,
  companies_ids,
  Last_updated_user_id = 1,
}) => {
  const {
    data: { cg_id },
  } = await axios.post(
    `/api/framework_agreements/${fa_id}/consortium_groups`,
    JSON.stringify({ fa_id: +fa_id, cg_name, Last_updated_user_id })
  );

  const { data } = await axios.post(
    `/api/framework_agreements/${fa_id}/consortium_groups/${cg_id}/companies`,
    JSON.stringify({
      fa_id: +fa_id,
      cg_id: +cg_id,
      companies_ids,
      company_type: 'supplier',
    })
  );

  return data;
};

export const useCreateConsortiumGroup = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: createConsortiumGroup,
    onSuccess: () => {
      enqueueSnackbar('Supplier consortium group successfully added to the framework agreement', {
        variant: 'success',
      });
    },
    onError: (error) => {
      //@ts-ignore
      const { response } = error;

      if (response?.data?.description) {
        enqueueSnackbar(
          response.data.description.toLowerCase().includes('duplicate key')
            ? 'Consortium group name already exists'
            : response.data.description.includes,
          { variant: 'error' }
        );
        //@ts-ignore
      } else enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
